import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLatestVersion } from '../data/changelogData';
import './Footer.css';

function Footer() {
  const version = useLatestVersion();
  const [utcDateStr, setUtcDateStr] = useState("");
  const [currentYear, setCurrentYear] = useState("");

  useEffect(() => {
    // Generate UTC string like "12 March 2026"
    const now = new Date();
    const day = now.getUTCDate();
    const month = now.toLocaleString('default', { month: 'long', timeZone: 'UTC' });
    const year = now.getUTCFullYear();
    
    setUtcDateStr(`${day} ${month} ${year}`);
    setCurrentYear(year.toString());
  }, []);

  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <i className="fa-solid fa-code-merge"></i> DevTracker
          </Link>
          <p className="brand-description">Track your coding journey across the world's best platforms in real-time.</p>
        </div>
        
        <div className="footer-links">
          <h3>Navigation</h3>
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/docs">Documentation</Link>
          <Link to="/sitemap">Sitemap</Link>
          <Link to="/report">Report an Issue</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="footer-links-group">
          <h3>Legal</h3>
          <div className="legal-nodes">
            <Link to="/privacy" className="legal-node">
              <i className="fa-solid fa-shield-halved"></i> Privacy Policy
            </Link>
            <Link to="/terms" className="legal-node">
              <i className="fa-solid fa-file-contract"></i> Terms & Conditions
            </Link>
          </div>
        </div>

        <div className="footer-social-group">
          <h3>Developer</h3>
          <div className="social-nodes">
            <a href="https://github.com" target="_blank" rel="noreferrer" className="social-node github">
              <i className="fa-brands fa-github"></i> GitHub
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" className="social-node twitter">
              <i className="fa-brands fa-twitter"></i> Twitter
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="social-node linkedin">
              <i className="fa-brands fa-linkedin"></i> LinkedIn
            </a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container bottom-content">
          <div className="copyright-area">
            <p>&copy; {currentYear} DevTracker. All rights reserved.</p>
            <span className="version-pill">{version}</span>
          </div>
          <p className="utc-note">Last Updated: {utcDateStr} (UTC)</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
